import { TerrainType, TERRAIN_TYPES, getTerrainById } from '../../constants/terrain';

export type { TerrainType };
export { getTerrainById };

export interface Chunk {
  data: Uint8Array;
  // Add other properties as needed
}

export class WorldGrid {
  private grid: TerrainType[][];

  constructor(width: number, height: number, defaultTerrain: TerrainType = TERRAIN_TYPES[0]) {
    this.grid = Array(height).fill(null).map(() => 
      Array(width).fill(defaultTerrain)
    );
  }

  getWidth(): number {
    return this.grid && this.grid[0] ? this.grid[0].length : 0;
  }

  getHeight(): number {
    return this.grid ? this.grid.length : 0;
  }

  getTile(x: number, y: number): TerrainType {
    if (this.grid && this.grid[y] && this.grid[y][x]) {
      return this.grid[y][x];
    }
    return TERRAIN_TYPES[0]; // Return default terrain instead of undefined
  }

  setTile(x: number, y: number, terrain: TerrainType): void {
    if (this.grid && this.grid[y]) {
      this.grid[y][x] = terrain;
    }
  }

  // ... other methods
}